import { guidesConfig } from "@/config/guides";
import type { GuideConfig } from "@/config/guides/types";

const ROUTE_PRIORITY: Array<{ test: (path: string) => boolean; guideId: string }> = [
  { test: p => p.startsWith("/workflows/edit"), guideId: "workflow-editor" },
  { test: p => p.startsWith("/workflows/history"), guideId: "workflow-history" },
  { test: p => p.startsWith("/workflows"), guideId: "platform-overview" },
  { test: p => p.startsWith("/templates"), guideId: "templates-overview" },
  { test: p => p.startsWith("/connectors"), guideId: "connectors-overview" },
  { test: p => p.startsWith("/integrations"), guideId: "integrations-overview" },
  { test: p => p.startsWith("/wallet-management"), guideId: "wallet-management" },
  { test: p => p.startsWith("/webhooks"), guideId: "webhooks-overview" },
  { test: p => p.startsWith("/billing"), guideId: "metrics-overview" },
];

export function getGuideForRoute(pathname: string | null | undefined): GuideConfig | null {
  if (!pathname) return null;
  const guides = (guidesConfig.guides as GuideConfig[]) || [];
  const match = ROUTE_PRIORITY.find(r => r.test(pathname));
  if (!match) return null;
  return guides.find(g => g.id === match.guideId) ?? null;
}
